import React from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import { Accordion } from "react-bootstrap";
import CategoryCreate from "../components/Categroy/CategoryCreate";
import CategoryEdit from "../components/Categroy/CategoryEdit";

function Tables() {
  const [categories, setCategories] = React.useState();
  const admin = useSelector((state) => state.admin);

  React.useEffect(() => {
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCategories = async () => {
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/categories`,
        headers: { Authorization: `Bearer ${admin.token}` },
      });

      response && setCategories(response.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  async function handleDelete(categoryId) {
    try {
      console.log(categoryId);
      await axios({
        method: "DELETE",
        url: `${process.env.REACT_APP_API_URL}/categories/${categoryId}`,
        headers: { Authorization: `Bearer ${admin.token}` },
      });
      getCategories();
    } catch (error) {
      console.log("Error: ", error);
    }
  }

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="content">
        <Row>
          <Col md="12">
            <Card className="card-plain">
              <CardHeader className="ps-0">
                <CardTitle tag="h4">Category List</CardTitle>
              </CardHeader>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Click to create a category
                  </Accordion.Header>
                  <Accordion.Body style={{ backgroundColor: "#F4F3EF" }}>
                    <CategoryCreate setCategories={setCategories} />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Accordion className="mt-3">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Click to update a category
                  </Accordion.Header>
                  <Accordion.Body style={{ backgroundColor: "#F4F3EF" }}>
                    <CategoryEdit
                      categories={categories}
                      setCategories={setCategories}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <CardBody>
                <Table responsive className="bg-white">
                  <thead className="text-primary">
                    <tr>
                      <th className="border text-center">Name</th>
                      <th className="border text-center">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories &&
                      categories
                        .map((category) => (
                          <tr key={category._id}>
                            <td className="text-center">{category.title}</td>
                            <td className="d-flex justify-content-center ">
                              <i
                                className="bi bi-trash3 fs-5"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleDelete(category._id);
                                }}
                              ></i>
                            </td>
                          </tr>
                        ))
                        .reverse()}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Tables;
